import { render, staticRenderFns } from "./sanctionList.vue?vue&type=template&id=73fcf2c1&scoped=true"
import script from "./sanctionList.vue?vue&type=script&lang=js"
export * from "./sanctionList.vue?vue&type=script&lang=js"
import style0 from "./sanctionList.vue?vue&type=style&index=0&id=73fcf2c1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73fcf2c1",
  null
  
)

export default component.exports